import React from 'react';
import { Box, Collapse } from '@mui/material';
import { alpha } from '@mui/material/styles';
import colors from '../../assets/theme/colors';
import SourceOriginalNotePanel from './SourceOriginalNotePanel';
import StoryCard from './StoryCard';
import { buildTimelineStoryPresentation } from './utils/timelineStorySections';

const StoryMomentParentInline = ({
  entry = {},
  expanded = false,
  getEntryPresentation = () => ({}),
  onCollapse = () => {},
}) => {
  const storyItem = entry.parentStory || null;
  const scenes = Array.isArray(storyItem?.sourceStoryScenes)
    ? storyItem.sourceStoryScenes
    : [];
  const originalNote = storyItem?.sourceStoryContext?.originalNote || '';
  const sourceAttachments = storyItem?.sourceStoryContext?.sourceAttachments || [];
  const storyPresentation = React.useMemo(
    () => buildTimelineStoryPresentation(scenes, { originalNote }),
    [originalNote, scenes]
  );

  if (!storyItem || !scenes.length) {
    return null;
  }

  const originalSourceNode = originalNote || sourceAttachments.length ? (
    <SourceOriginalNotePanel
      originalNote={originalNote}
      sourceAttachments={sourceAttachments}
      sourceNoteId={storyItem.sourceNoteId || entry.sourceNoteId || ''}
      showSourceReviewActions={false}
      showGenericCareDetails={false}
      requireKnowledgeItems={false}
      variant="header"
    />
  ) : null;

  return (
    <Collapse in={expanded} timeout="auto" unmountOnExit>
      <Box
        data-testid="inline-parent-story"
        sx={{
          mt: 0.85,
          p: { xs: 0.75, sm: 0.9 },
          borderRadius: '16px',
          border: `1px solid ${alpha(colors.brand.deep, 0.2)}`,
          bgcolor: alpha(colors.brand.tint, 0.12),
        }}
      >
        <StoryCard
          storyItem={storyItem}
          storySections={storyPresentation.sections}
          storySummary={storyPresentation.summary}
          getEntryPresentation={getEntryPresentation}
          expanded
          onToggleExpanded={onCollapse}
          previewText={storyPresentation.summary?.text || scenes[0]?.body || ''}
          originalSourceNode={originalSourceNode}
          menuActions={[]}
          showActions={false}
        />
      </Box>
    </Collapse>
  );
};

export default StoryMomentParentInline;
